<template>
  <el-dialog
    top="50px"
    width="800px"
    title="Cấu hình giá sản phẩm"
    :visible="visible"
    :show-close="!callingAPI"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="$emit('close')"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      size="medium"
      class="card-form"
      label-position="top"
    >
      <el-row
        :gutter="24"
        class="mb-m"
      >
        <el-col :span="6">
          <b>Mã gói</b>
        </el-col>
        <el-col :span="8">
          <b>Tên gói</b>
        </el-col>
        <el-col :span="6">
          <b>Giá gói</b>
        </el-col>
        <el-col
          :span="4"
          style="display: flex; align-items: center; justify-content: center;"
        >
          <b>Private</b>
        </el-col>
      </el-row>
      <el-row
        v-for="(pkg, index) in form.packages"
        :key="index"
        :gutter="24"
      >
        <el-col :span="6">
          <el-form-item
            :prop="`packages.${index}.code`"
            label=""
          >
            <el-input
              v-model="pkg.code"
              readonly
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :prop="`packages.${index}.label`"
            label=""
            :rules="[
              { required: true, message: 'Tên gói là bắt buộc', trigger: 'blur' },
            ]"
          >
            <el-input
              v-model="pkg.label"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :prop="`packages.${index}.price`"
            label=""
          >
            <el-input-number
              v-model="pkg.price"
              class="w-100"
            />
          </el-form-item>
        </el-col>
        <el-col
          :span="4"
          style="display: flex; align-items: center; justify-content: center;"
        >
          <el-form-item
            :prop="`packages.${index}.hide`"
            label=""
          >
            <el-switch
              v-model="pkg.hide"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        :disabled="callingAPI"
        size="medium"
        @click="$emit('close')"
      >
        Đóng
      </el-button>
      <el-button
        type="primary"
        :loading="callingAPI"
        size="medium"
        @click="handleConfirm"
      >
        Lưu
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import commonServices from "@/services/common";
import {
  notification,
  convertPayloadData,
} from "@/utils/common";
import constants, { DEFAULT_PACKAGES } from "@/config/constants";

export default {
  name: "PackagesFormPopup",
  components: {
  },
  props: {
    item: Object,
    config: Object,
    visible: Boolean,
  },
  data() {
    return {
      form: {
        packages: this.item.extra.packages || DEFAULT_PACKAGES
      },
      callingAPI: false,
    };
  },
  computed: {
    rules() {
      return {}
    },
    objectType() {
      return constants.OBJECT_TYPES.find((t) => t.value === this.config.type);
    },
    fields() {
      return (this.config.extra.fields || [])
        .filter((f) => this.selectedGroup.fields.includes(f.key))
        .sort((a, b) => a.order - b.order);
    },
  },
  methods: {
    handleConfirm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.callingAPI = true;
          commonServices
            .update(
              this.config.type,
              convertPayloadData(this.config.extra.key, {
                ...this.item,
                extra: {
                  ...this.item.extra,
                  ...this.form,
                },
              })
            )
            .then(() => {
              this.callingAPI = false;
              notification(
                this,
                "success",
                "update",
                `${this.config.extra.name}`
              );
              this.$emit('reload');
              this.$emit('close');
            })
            .catch(() => {
              this.callingAPI = false;
              notification(
                this,
                "error",
                "update",
                `${this.config.extra.name}`
              );
            });
        }
      });
    },
  },
};
</script>

<style lang="scss">
.tab-form-popup {
  .el-dialog__body {
    .el-tabs__content {
      min-height: 50vh;
      max-height: 60vh;
      overflow: auto;
    }
  }
}
</style>
